<template>
  <ul class="flex w-full flex-col gap-2" v-if="data">
    <li
      role="button"
      class="dark:bg-ontick-graphite-500 border-ontick-steel-300 hidden w-full transform-gpu items-center justify-between gap-2 overflow-hidden rounded-md border-2 shadow-lg filter transition-all ease-in-out hover:scale-105 hover:brightness-110 dark:border-0 lg:flex"
      :class="{ 'brightness-150': selectedIndex === index }"
      v-for="(item, index) in data"
      @click="openDetails(index)"
      :key="`${item.strategy_id}${index}`"
    >
      <div
        :content="item.strategy_developer"
        v-tippy="{ arrow: true, theme: 'green' }"
        class="bg-ontick-steel-400 z-20 flex items-center self-stretch pl-4 pr-2 dark:bg-transparent"
      >
        <img
          src="/img/icons/android-chrome-192x192.png"
          :alt="item.strategy_developer"
          class="h-10 w-10"
          v-if="!item.partner_badge || item.strategy_developer === 'OnTick'"
        />
        <img :src="item.partner_badge" :alt="item.strategy_developer" class="h-10 w-10" v-else />
      </div>
      <div class="ml-2 flex-grow py-2">
        <p class="font-bold">
          {{ item.strategy_name }}
        </p>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          {{ item.strategy_symbol }}
        </p>
      </div>
      <dl>
        <dt>Fator de lucro</dt>
        <dd
          v-if="item.profit_factor === 'N/D'"
          content="Esta estratégia não teve perdas no período analisado, portanto o fator de lucro é indefinido."
          v-tippy="{ arrow: true, theme: 'green' }"
        >
          {{ item.profit_factor }}
        </dd>
        <dd v-else>{{ item.profit_factor.toFixed(1) }}x</dd>
      </dl>
      <dl>
        <dt>Tx. de acerto</dt>
        <dd>{{ item.win_ratio ? item.win_ratio.toFixed(1) : "ph" }}%</dd>
      </dl>
      <dl>
        <dt>Operações</dt>
        <dd>{{ item.num_trades }}</dd>
      </dl>
      <dl>
        <dt>Resultado</dt>
        <dd class="flex items-center gap-1">
          <i v-if="item.pnl !== 0" v-html="item.pnl > 0 ? $icons.play_green : $icons.play_red"></i>
          <span>
            {{ item.pnl | currency }}
          </span>
        </dd>
      </dl>
    </li>
    <li
      class="dark:bg-ontick-graphite-500 border-ontick-steel-300 dark:divide-ontick-steel-500 divide-ontick-steel-300 flex w-full flex-col divide-y rounded-lg border-2 p-4 shadow-lg dark:border-0 lg:hidden"
      role="button"
      v-for="(item, index) in data"
      @click="openDetails(index)"
      :key="`${item.strategy_id}${index}mobile`"
    >
      <div class="flex items-center gap-2 pb-4">
        <div
          :content="item.strategy_developer"
          v-tippy="{ arrow: true, theme: 'green' }"
          class="bg-ontick-steel-400 z-20 flex items-center self-stretch rounded p-2 dark:rounded-none dark:bg-transparent dark:p-0"
        >
          <img :src="item.partner_badge" :alt="item.strategy_developer" class="h-10 w-10" />
        </div>
        <div class="ml-2 flex-grow">
          <p class="font-bold">
            {{ item.strategy_name }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ item.strategy_symbol }}
          </p>
        </div>
      </div>
      <div class="grid grid-cols-2 md:grid-cols-4">
        <dl>
          <dt>Fator de lucro</dt>
          <dd
            v-if="item.profit_factor === 'N/D'"
            content="Esta estratégia não teve perdas no período analisado, portanto o fator de lucro é indefinido."
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            {{ item.profit_factor }}
          </dd>
          <dd v-else>{{ item.profit_factor }}x</dd>
        </dl>
        <dl>
          <dt>Tx. de acerto</dt>
          <dd>{{ item.win_ratio ? item.win_ratio.toFixed(1) : "ph" }}%</dd>
        </dl>
        <dl>
          <dt>Operações</dt>
          <dd>{{ item.num_trades }}</dd>
        </dl>
      </div>
      <dl>
        <dt>Resultado</dt>
        <dd class="flex items-center gap-1">
          <i v-if="item.pnl !== 0" v-html="item.pnl > 0 ? $icons.play_green : $icons.play_red"></i>
          <span>
            {{ item.pnl | currency }}
          </span>
        </dd>
      </dl>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
    },
    selectedIndex: {
      type: Number,
    },
  },

  methods: {
    openDetails(index) {
      this.$emit("open-details", index);
    },
  },
};
</script>

<style lang="scss" scoped>
dl {
  @apply flex flex-col py-4 last-of-type:mr-4 last-of-type:pb-0 lg:w-[85px] lg:items-end lg:py-2 lg:text-right lg:last-of-type:w-[150px];
  dt {
    @apply text-xs text-gray-500 dark:text-gray-400;
  }
  dd {
    @apply font-bold;
  }
}
</style>
